import { useEffect, useState } from "react";
import NavBar from "../../../components/organisms/navbar";
import {
  Container,
  Content,
  InfoContainerStatus,
  InfoContainerText,
  PageTitle,
  PageTitleContainer,
  StatusButton,
  SubscriptionContainer,
  SubscriptionContent,
  SubscriptionDescription,
  SubscriptionItem,
  SubscriptionList,
  SubscriptionTitle,
} from "../../profile/subscriptions/styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import useAuthenticate from "../../../hooks/useAuthenticate";
import Loading from "../../../components/atoms/loading";
import React from "react";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate, useParams } from "react-router-dom";
import { StringToSlug, StringToSlugPraia } from "../../../utils/SlugConverter";
import { TournamentLink } from "src/pages/tournament/styles";
import { FormContent } from "src/pages/auth/change-password/styles";
import { useForm } from "react-hook-form";
import { FormGroup } from "../../../pages/auth/login/styles";
import Input from "../../../components/atoms/input";
import BasicModal from "src/components/organisms/tournamentBracket/modal";
import Swal from "sweetalert2";
import { Box, Button, Fab, Typography, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const AllCheckCategoriesCopaMestreDoAcaiKidsDeJiuJitsu2025 = () => {
  //let senha = "teste"
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  let password = {
    torneio: "copamestreacaikids@2025",
    credenciais: {
      usuario: "copamestreacaikids",
      senha: "copamestreacaikids@2025",
    },
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getToken, account } = useAuthenticate();
  const [dataTratada, setDataTratada] = useState<
    { category: string; figthers: any }[]
  >([]);
  const [showData, setShowData] = useState(false);
  const url = window.location.pathname;
  const { slug } = useParams();
  const [tournament, setTournament] = useState<any>({});
  const [subscription, setSubscription] = useState<any>([]);
  const [senha, setSenha] = useState(""); // Estado para armazenar o valor da senha digitada
  const [isAuthorized, setIsAuthorized] = useState(false); // Estado para controlar a exibição do relatório
  const navigate = useNavigate();
  const [manager, setManager] = useState<boolean>(false);
  const [visible, setVisible] = useState(false);

  const handleCheckPassword = (data: any) => {
    if (data.password === password.credenciais.senha) {
      setIsAuthorized(true); // Exibe o relatório se a senha estiver correta
    } else {
      alert("Senha incorreta"); // Exibe um alerta se a senha estiver errada
    }
  };

  const handleEditFighter = (fighterId: number) => {

    if (manager) {
      Swal.fire({
        title: "Como deseja editar sua inscrição?",
        text: "Você pode editar seguindo as regras do evento ou livremente.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: '#373737',
        confirmButtonText: "Editar com regras",
        denyButtonText: "Editar sem regras",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) navigate(`/enrollment-update/${fighterId}/${slug}`, { state: { from: url, mode: 'regras' } });
        else if (result.isDenied) navigate(`/enrollment-update/${fighterId}/${slug}`, { state: { from: url, mode: 'livre' } });
      });
    } else {
      navigate(`/enrollment-update/${fighterId}/${slug}`, { state: { from: url } });
    }

  }

  const normalize = (v: unknown) =>
    (v ?? "").toString().trim().toLowerCase();

  // "parajiu jitusu - adulto" -> "adulto"
  const normalizeCategory = (cat: unknown) => {
    const n = normalize(cat);
    if (!n) return n;
    const parts = n.split("-").map(p => p.trim());
    return parts[parts.length - 1] || n;
  };

  const getOrder = <T extends string>(
    map: Record<string, number>,
    key: unknown,
    fallback = 999
  ) => map[normalize(key as string)] ?? fallback;

  // "parajiu jitusu - adulto" -> "adulto"
  const baseCategory = (raw: unknown) => {
    const n = normalize(raw);
    if (!n) return n;
    const parts = n.split("-").map(p => p.trim());
    return parts[parts.length - 1] || n;
  };

  const beltOrderSafe = (beltRaw: unknown, beltMap: Record<string, number>) => {
    const b = normalize(beltRaw);
    if (!b) return 999;

    // 1) Se existir "cinza e amarela" no mapa, usa direto (RESOLVE seu caso)
    if (b in beltMap) return beltMap[b];

    // 2) Senão, se for combinado, deriva a ordem pelas partes
    if (b.includes(" e ")) {
      const parts = b.split(" e ").map(x => x.trim());
      const nums = parts.map(p => beltMap[p] ?? 999);
      // pode usar Math.min (mais "leve") ou Math.max (mais "alta")
      return Math.min(...nums);
    }

    // 3) Faixa simples
    return beltMap[b] ?? 999;
  };

  const weightOrderSafe = (wRaw: unknown, wMap: Record<string, number>) =>
    wMap[normalize(wRaw)] ?? 999;

  // força feminino antes de masculino
  const genderOrderMap: Record<string, number> = {
    "feminino": 1,
    "masculino": 2,
  };

  const genderOrderSafe = (gRaw: unknown) =>
    genderOrderMap[normalize(gRaw)] ?? 99;

  // extrai campos do seu `title` "categoria/gênero/faixa/peso"
  const parseTitle = (title: string) => {
    const [cat, gen, belt, weight] = title.split("/");
    return {
      catRaw: cat ?? "",
      genRaw: gen ?? "",
      beltRaw: belt ?? "",
      weightRaw: weight ?? "",
      catBase: baseCategory(cat),
    };
  };

  const isParaOrPCD = (catRaw: unknown) => {
    const c = normalize(catRaw);
    // considera "pcd ..." ou "parajiu ..." (qualquer variação de espaços/letras)
    return c.startsWith("pcd") || c.startsWith("parajiu");
  };

  // PRIMEIRO FEMININO DEPOIS MASCULINO

  const categoryOrder: { [key: string]: number } = {
    "pré-mirim": 1,
    "mirim a": 2,
    "mirim b": 3,
    "infantil a": 4,
    "infantil b": 5,
    "infanto juvenil": 6,
    juvenil: 7,
    adulto: 8,
    "master 1 e 2": 9,
    "master 3, 4 e 5": 10,
  };

  const beltOrder: { [key: string]: number } = {
    'luta casada': 1,
    branca: 2,
    cinza: 3,
    amarela: 4,
    laranja: 5,
    verde: 6,
    'laranja e verde': 7,
    azul: 8,
    roxa: 9,
    marrom: 10,
    preta: 11,
  };

  const weightOrder: { [key: string]: number } = {
    galo: 1,
    pluma: 2,
    pena: 3,
    leve: 4,
    médio: 5,
    "meio pesado": 6,
    pesado: 7,
    "super pesado": 8,
    pesadíssimo: 9,
    absoluto: 10,
  };

  interface User {
    id: number;
    name: string;
    phone: string;
    email: string;
    gym: string;
    genre: string;
  }

  interface Fighter {
    id: number;
    weight: string;
    genre: string;
    age: string;
    belt: string;
    category: string;
    valueSubscription: string;
    status: boolean;
    created_at: string;
    updated_at: string;
    userId: number;
    fightersId: number | null;
    tournamentId: number;
    fighters: any;
    user: User;
  }

  function converterSubscriptions(array: any) {
    const subscriptions: {
      id: any;
      weight: any;
      age: any;
      gender: any;
      genderBool: string;
      belt: any;
      category: any;
      name: any;
      gymAbre: any;
      gym: any;
      status: any;
      value: any;
      categoryw: any;
    }[] = [];
    array.forEach((item: any) => {
      let fighterBelt = item.belt;
      if (item.belt === "laranja" || item.belt === "verde") {
        fighterBelt = "laranja e verde";
      }
      if (item.belt === "cinza" || item.belt === "amarela") {
        fighterBelt = "cinza e amarela";
      }

      let category;

      category = StringToSlug(
        `${fighterBelt}/${item.genre}/${item.weight}/${item.category}`
      );

      if (item.fighters && item.status) {
        subscriptions.push({
          id: item.id,
          weight: item.weight,
          age: item.age,
          gender: item.fighters.genre,
          genderBool:
            item.fighters.genre === "Masculino" ? "Falso" : "Verdadeiro",
          belt: item.belt,
          category: item.category,
          name: item.fighters.name,
          gymAbre: item.fighters.gym.substring(0, 12),
          gym: item.fighters.gym,
          status: item.status,
          categoryw: category, // This `categoryw` is the slug, not used for sorting here
          value: item.valueSubscription,
        });
      }

      if (!item.fighters && item.status) {
        subscriptions.push({
          id: item.id,
          weight: item.weight,
          age: item.age,
          gender: item.user.genre,
          genderBool: item.user.genre === "masculino" ? "Falso" : "Verdadeiro",
          belt: item.belt,
          category: item.category,
          name: item.user.name,
          gymAbre: item.user.gym.substring(0, 12),
          gym: item.user.gym,
          status: item.status,
          categoryw: category, // This `categoryw` is the slug, not used for sorting here
          value: item.valueSubscription,
        });
      }
    });

    function categorizeParticipants(participants: any) {
      let categories: any = {};

      participants.forEach((participant: any) => {
        let fighterBelt = participant.belt;
        if (participant.belt === "laranja" || participant.belt === "verde") {
          fighterBelt = "laranja e verde";
        }
        if (participant.belt === "cinza" || participant.belt === "amarela") {
          fighterBelt = "cinza e amarela";
        }

        const categoryIdentifier = `${participant.category.toLowerCase()}/${participant.genre.toLowerCase()}/${fighterBelt.toLowerCase()}/${participant.weight.toUpperCase()}`;

        if (!categories[categoryIdentifier]) {
          categories[categoryIdentifier] = [];
        }

        categories[categoryIdentifier].push(participant);
      });

      let categoriesArray = Object.keys(categories).map((title) => {
        const { catRaw, genRaw, beltRaw, weightRaw, catBase } = parseTitle(title);

        return {
          title,
          data: categories[title],
          // 0 = normal; 1 = PCD/Parajiu  → empurramos pro final
          prefixOrderVal: isParaOrPCD(catRaw) ? 1 : 0,

          // ordem já corrigida anteriormente
          categoryOrderVal: categoryOrder[catBase] ?? 999,
          genderOrderVal: genderOrderSafe(genRaw),
          beltOrderVal: beltOrderSafe(beltRaw, beltOrder),
          weightOrderVal: weightOrderSafe(weightRaw, weightOrder),
        };
      });

      categoriesArray.sort((a, b) => {
        // 1) Normal antes; PCD/Parajiu no fim
        if (a.prefixOrderVal !== b.prefixOrderVal) {
          return a.prefixOrderVal - b.prefixOrderVal;
        }
        // 2) Categoria (sufixo após "-")
        if (a.categoryOrderVal !== b.categoryOrderVal) {
          return a.categoryOrderVal - b.categoryOrderVal;
        }
        // 3) Gênero (feminino antes de masculino)
        if (a.genderOrderVal !== b.genderOrderVal) {
          return a.genderOrderVal - b.genderOrderVal;
        }
        // 4) Faixa
        if (a.beltOrderVal !== b.beltOrderVal) {
          return a.beltOrderVal - b.beltOrderVal;
        }
        // 5) Peso
        return a.weightOrderVal - b.weightOrderVal;
      });

      setSubscription(categoriesArray);
      const dataTratadaArr: { category: string; figthers: any }[] = [];

      categoriesArray.forEach((category) => {
        dataTratadaArr.push({
          category: category.title,
          figthers: category.data.map((item: { fighters: any; user: any }) => {
            if (item.fighters == null) {
              return {
                name: item.user.name,
                gym: item.user.gym,
              };
            } else {
              return {
                name: item.fighters.name,
                gym: item.fighters.gym,
              };
            }
          }),
        });
      });

      setDataTratada(dataTratadaArr);
    }

    categorizeParticipants(array);
  }

  useEffect(() => {
    if (account?.roles?.includes('manager') || tournament.authorId === account.id) {
      setManager(true);
    } else {
      setManager(false);
    }
  }, [account]);

  useEffect(() => {
    setLoading(true);

    api
      .get("/tournaments/" + slug)
      .then(({ data }) => {
        setTournament(data);
      })
      .catch(() => {
        toast.error("Não foi carregar os dados do torneio.");
      });

    api
      .get("/tournaments/enrollments/list-all/public/" + slug, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(({ data }) => {
        console.log(data);
        setLoading(false);

        const sortedArray = data
          .filter((item: Fighter) => item.status === true)
          .slice()
          .sort((a: Fighter, b: Fighter) => {
            const aGenre = normalize(a.genre);
            const bGenre = normalize(b.genre);

            // 1) Feminino antes de Masculino
            if (aGenre !== bGenre) {
              if (aGenre === "feminino") return -1;
              if (bGenre === "feminino") return 1;
            }

            // 2) Categoria (usando sufixo após "-")
            const aCat = normalizeCategory(a.category);
            const bCat = normalizeCategory(b.category);
            const catDiff = getOrder(categoryOrder, aCat) - getOrder(categoryOrder, bCat);
            if (catDiff !== 0) return catDiff;

            // 3) Faixa (belt)
            const beltDiff = beltOrderSafe(a.belt, beltOrder) - beltOrderSafe(b.belt, beltOrder);
            if (beltDiff !== 0) return beltDiff;

            // 4) Peso
            const weightDiff = getOrder(weightOrder, a.weight) - getOrder(weightOrder, b.weight);
            if (weightDiff !== 0) return weightDiff;

            // (opcional) 5) Desempate por nome para estabilidade
            const aName = normalize(a.user?.name);
            const bName = normalize(b.user?.name);
            return aName.localeCompare(bName);
          });

        setData(sortedArray);

        if (data && subscription.length === 0)
          converterSubscriptions(sortedArray);

        setShowData(true);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Não foi carregar os dados das inscrições.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300); // mostra só depois de rolar 300px
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) return <Loading text="Aguarde, estamos processando os dados." />;

  let quantidadeInscrcaoPagas = data.length;
  let quatidadeDeChaves = subscription.filter(
    (item: any) => item.data.length > 0
  ).length;
  let quatidadeDeChavesSemLuta = subscription.filter(
    (item: any) => item.data.length === 1
  ).length;

  let medalhasBronze = subscription.filter(
    (item: any) => item.data.length > 2
  ).length;
  let medalhasPrata =
    medalhasBronze +
    subscription.filter((item: any) => item.data.length === 2).length;
  let medalhasOuro =
    medalhasPrata +
    subscription.filter((item: any) => item.data.length === 1).length;

  console.log(medalhasOuro, medalhasPrata, medalhasBronze);

  return (
    <>
      <NavBar />
      <Container>
        <Content id="todaslutas">
          <PageTitleContainer>

            <Typography sx={{ fontSize: '2.0rem', fontFamily: 'inter, sans-serif', fontWeight: 400 }}>
              CHECAGEM {tournament.name}
            </Typography>

            <Typography sx={{ color: 'red', fontSize: '1.8rem', fontFamily: 'inter, sans-serif' }}>
              Somente inscrições pagas aparecem na checagem
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, mt: 2 }}>
              <Button
                variant="contained"
                sx={{ backgroundColor: '#373737', fontFamily: 'inter, sans serif' }}
                onClick={() => {
                  const section = document.getElementById('semlutas');
                  section?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Chaves sem lutas
              </Button>

              <Button
                variant="contained"
                sx={{ backgroundColor: '#373737', fontFamily: 'inter, sans serif' }}
                onClick={() => {
                  const section = document.getElementById('relatorioTorneio');
                  section?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Relatório do Torneio
              </Button>

              {account.id == 34 && (
                <BasicModal
                  chaves={dataTratada}
                  tournamentId={tournament.id}
                  tournamentName={tournament.name}
                  tournamentDate={tournament.date}
                  tournamentLocation={tournament.location}
                  tournamentRules={tournament.rules}
                />
              )}
            </Box>

            <Typography sx={{ fontSize: '1.8rem', fontFamily: 'inter, sans-serif', fontWeight: 'bold', mt: 3 }}>
              TODAS AS LUTAS:
            </Typography>

          </PageTitleContainer>

          <SubscriptionContainer>
            {/* renderizar as inscrições para cada categoria */}
            {subscription.map((item: any) => {
              // mostrar as inscrições apenas se houver atletas na categoria atual

              item.data.sort((a: any, b: any) => {
                const nomeA = (
                  a.fighters ? a.fighters.name : a.user.name
                ).toLowerCase();
                const nomeB = (
                  b.fighters ? b.fighters.name : b.user.name
                ).toLowerCase();
                return nomeA.localeCompare(nomeB);
              });

              if (showData) {
                return (
                  <React.Fragment key={item.title}>
                    <br></br>
                    <PageTitle>{item.title}</PageTitle>
                    {item.data.map((value: any, index: number) => (
                      <SubscriptionList key={value.id}>
                        <SubscriptionItem>
                          <SubscriptionContent>
                            {/* <SubscriptionTitle>
                              Inscrição Nº {value.id} -{tournament.name}
                            </SubscriptionTitle> */}
                            {/* <br /> */}
                            <SubscriptionDescription>
                              <InfoContainerText>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <div style={{ flexGrow: 1 }}>
                                    <span>
                                      <b>{index + 1}. </b>
                                      {(value.fighters
                                        ? value.fighters.name
                                        : value.user.name
                                      ).toLocaleUpperCase()}{" "}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      flexShrink: 0,
                                      textAlign: "right",
                                    }}
                                  >
                                    <span>
                                      {(value.fighters
                                        ? value.fighters.gym
                                        : value.user.gym
                                      ).toLocaleUpperCase()} {' '}
                                    </span>

                                    {(value.userId === account.id || manager) && (
                                      <EditIcon color="action" onClick={() => handleEditFighter(value.id)} />
                                    )}

                                  </div>
                                </div>

                                {/* <span>Professor: ORLEY LOBATO</span><br/> */}
                              </InfoContainerText>
                            </SubscriptionDescription>
                          </SubscriptionContent>
                        </SubscriptionItem>
                      </SubscriptionList>
                    ))}
                    <br></br> <br></br>
                  </React.Fragment>
                );
              } else {
                // não há atletas nesta categoria, então não renderizar nada
                return null;
              }
            })}
          </SubscriptionContainer>
        </Content>

        <Content id="semlutas">
          <PageTitleContainer>

            <Typography sx={{ fontSize: '1.8rem', fontFamily: 'inter, sans-serif', fontWeight: 'bold', mt: 2 }}>
              {
                subscription.filter((item: any) => item.data.length === 1)
                  .length
              } CHAVES SEM LUTAS:
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, mt: 2 }}>
              <Button
                variant="contained"
                sx={{ backgroundColor: '#373737', fontFamily: 'inter, sans serif' }}
                onClick={() => {
                  const section = document.getElementById('semlutas');
                  section?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Chaves sem lutas
              </Button>

              <Button
                variant="contained"
                sx={{ backgroundColor: '#373737', fontFamily: 'inter, sans serif' }}
                onClick={() => {
                  const section = document.getElementById('relatorioTorneio');
                  section?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Relatório do Torneio
              </Button>
            </Box>

          </PageTitleContainer>

          <SubscriptionContainer>
            {/* renderizar as inscrições para cada categoria */}
            {subscription
              .filter((item: any) => item.data.length === 1)
              .map((item: any) => {
                // mostrar as inscrições apenas se houver atletas na categoria atual

                item.data.sort(function (
                  a: { age: number },
                  b: { age: number }
                ) {
                  if (a.age > b.age) {
                    return 1;
                  }
                  if (a.age < b.age) {
                    return -1;
                  }
                  // a must be equal to b
                  return 0;
                });

                if (showData) {
                  return (
                    <React.Fragment key={item.title}>
                      <PageTitle>{item.title}</PageTitle>
                      {item.data.map((value: any, index: number) => (
                        <SubscriptionList key={value.id}>
                          <SubscriptionItem>
                            <SubscriptionContent>
                              <SubscriptionTitle>
                                Inscrição Nº {value.id} -{tournament.name}
                              </SubscriptionTitle>
                              {/* <br /> */}
                              <SubscriptionDescription>
                                <InfoContainerText>
                                  {/* <b>Inscrição: {index + 1}°</b>{" "} */}
                                  <span>sem luta</span>
                                  <span>
                                    <b>Nome:</b>{" "}
                                    {value.fighters
                                      ? value.fighters.name
                                      : value.user.name}
                                  </span>
                                  <span>
                                    <b>Academia: </b>{" "}
                                    {value.fighters
                                      ? value.fighters.gym
                                      : value.user.gym}
                                  </span>
                                  <span>
                                    <b>Faixa: </b> {value.belt}
                                  </span>
                                  {/* <span>Professor: ORLEY LOBATO</span><br/> */}
                                </InfoContainerText>
                                <InfoContainerStatus>
                                  <StatusButton status={value.status}>
                                    <span>
                                      {value.status
                                        ? "Pagamento efetuado"
                                        : "Pendente de pagamento"}
                                    </span>
                                  </StatusButton>
                                </InfoContainerStatus>
                              </SubscriptionDescription>
                            </SubscriptionContent>
                          </SubscriptionItem>
                        </SubscriptionList>
                      ))}
                    </React.Fragment>
                  );
                } else {
                  // não há atletas nesta categoria, então não renderizar nada
                  return null;
                }
              })}
          </SubscriptionContainer>
        </Content>

        <Content
          id="relatorioTorneio"
          style={{ alignContent: "left", justifyContent: "left" }}
        >
          {/* Campo de entrada para a senha */}
          <div
            style={{ display: "flex", flexDirection: "column", width: "200px" }}
          >
            <FormContent onSubmit={handleSubmit(handleCheckPassword)}>
              <FormGroup>
                <Input
                  label="Senha"
                  name="password"
                  type="password"
                  register={register}
                  required
                  error="Este campo é obrigatório"
                  trim={true}
                />
              </FormGroup>
              <FormGroup>
                <Button type="submit">
                  Entrar
                </Button>
              </FormGroup>
            </FormContent>
          </div>

          {/* Botão para verificar a senha */}
          {isAuthorized && (
            <>
              <h1>Relatório de Inscrições</h1>
              <h2>{quantidadeInscrcaoPagas} Inscrições</h2>
              <h2>{quatidadeDeChaves} Total de Chaves</h2>
              <h2>{quatidadeDeChavesSemLuta} Chaves sem Luta</h2>
              <h2>
                {quatidadeDeChaves - quatidadeDeChavesSemLuta} Chaves com luta
              </h2>

              <h1>Relatório de Medalhas</h1>
              <h2>{medalhasOuro} Ouro</h2>
              <h2>{medalhasPrata} Prata</h2>
              <h2>{medalhasBronze} Bronze</h2>
              <hr />

              <h1> Todas as incrições</h1>

              <TournamentLink
                href={`/subscription/by-owner/${tournament.slug}`}
              >
                Ver Todas As Inscrições
              </TournamentLink>
              <TournamentLink href={`/reportDetail/tournament/${slug}`}>
                Relatório detalhado
              </TournamentLink>
            </>
          )}
        </Content>

        <Zoom in={visible}>
          <Fab
            color="primary"
            size="medium"
            onClick={scrollToTop}
            sx={{
              position: "fixed",
              bottom: 24,
              right: 24,
              backgroundColor: '#373737',
              borderRadius: "50%", // garante que fique redondo
            }}
          >
            <KeyboardArrowUpIcon />
          </Fab>
        </Zoom>

      </Container>
    </>
  );
};

export default AllCheckCategoriesCopaMestreDoAcaiKidsDeJiuJitsu2025;
